import { render } from "./gz.vue?vue&type=template&id=03716134&scoped=true"
import script from "./gz.vue?vue&type=script&lang=js"
export * from "./gz.vue?vue&type=script&lang=js"

import "./gz.vue?vue&type=style&index=0&id=03716134&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03716134"]])

export default __exports__